import { Dropdown, HStack, Icon } from '@/components/sgBootstrapReactWrapper';
import type { OtherServicesURLs } from '@/config/AppConfig';
import { getOtherServicesURL } from '@/config/config';
import { isEmpty, isNotDefined } from '@/utils/assertions';
import { FormattedMessage } from 'react-intl';

type Props = {
  entity: 'LUX' | 'MCO';
  service: keyof OtherServicesURLs;
};

export const OtherServicesDropdownitem = ({ entity, service }: Props) => {
  const url = getOtherServicesURL(entity, service);

  if (isNotDefined(url) || isEmpty(url)) {
    return;
  }

  return (
    <Dropdown.Item
      key={service}
      onClick={() => window.open(getOtherServicesURL(entity, service), service)}
    >
      <HStack>
        <FormattedMessage id={`otherServices.${service}`} />
        <Icon icon="open_in_new" size="sm" className="ps-4px" />
      </HStack>
    </Dropdown.Item>
  );
};
